import { SectionHeaderBarActions } from '../../../../../../common/components/SectionHeaderBarActions';
import { ExportIncompleteApplicationsButton } from './components/ExportIncompleteApplicationsButton';

export const HeaderBarActions = () => {
    return (
        <SectionHeaderBarActions>
            <div style={{ marginLeft: 'auto' }}>
                <ExportIncompleteApplicationsButton />
            </div>
        </SectionHeaderBarActions>
    );
};
